import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  meta: {
    title: {
      de: 'Impressum',
      en: 'Imprint'
    },
    description: {
      de: 'Impressum und rechtliche Informationen der S+D Holding GmbH',
      en: 'Imprint and legal information of S+D Holding GmbH'
    }
  },
  title: {
    de: 'Impressum',
    en: 'Imprint'
  }
}); 